import { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import isUndefined from 'lodash-es/isUndefined';

import { withRuntimeConfigServerSideProps } from '@catawiki/next-config/runtime-config';
import { InternalLocale } from '@catawiki/locale';

import { fetchAssets } from '@/shared/helpers/api/assets';
import {
  RegisterPage,
  RegisterPageProps,
} from '@/pages/RegisterPage/RegisterPage';
import { getUserAuthentication } from '@/shared/helpers/api/getUserAuthentication';

const getServerSidePropsInner: GetServerSideProps<RegisterPageProps> = async (
  context
) => {
  const { locale = InternalLocale.ENGLISH } = context;

  const auth = await getUserAuthentication(context);

  const [assetsData, translations] = await Promise.all([
    fetchAssets(locale),
    serverSideTranslations(locale),
  ]);

  const APP_IMGPROXY_HOST = process.env.APP_IMGPROXY_HOST;
  if (isUndefined(APP_IMGPROXY_HOST)) {
    throw new Error(
      'The APP_IMGPROXY_HOST is missing. Did you forget to update your .env with the latest values from the vault?'
    );
  }

  return {
    props: {
      isUserLoggedIn: auth.isAuthenticated,
      APP_IMGPROXY_HOST,
      assetsData,
      locale,
      pageType: 'sellerRegister',
      showCookieBanner: true,
      ...translations,
    },
  };
};

export const getServerSideProps = withRuntimeConfigServerSideProps(
  getServerSidePropsInner
);

export default RegisterPage;
